import { BIRDVIEW_HOME_CONTACT_TOOLTIP_KEY } from './BirdviewHomeRow.constants'

export function checkIsBirdviewHomeContact({ type }) {
  return Boolean(type)
}

export function getBirdviewHomeContactTooltipKey({ type }) {
  return BIRDVIEW_HOME_CONTACT_TOOLTIP_KEY[type]
}
